import React, { useEffect, useMemo, useState } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import useQueryParams from "query-params-hook"
import SciplayGames from "./sciplay-games"
import Stores, { StoreType } from "./stores"
import { replaceByDict } from "../utilities/replace-by-dict"

const Footer = ({ isLpPage }: { isLpPage?: boolean }) => {
  const { page_version, campaignid, adgroupid, keyword, adid, lpurl, gclid} = useQueryParams()
  const [isLoading, setIsLoading] = useState(true);
  const [lightVersion, setLightVersion] = useState(false);

  useEffect(() => {
    setLightVersion(!!page_version);
    setIsLoading(false);
  }, [page_version]);

  const replaceHashed = useMemo(
    () => ({ campaignid, adgroupid, keyword, adid, lpurl, gclid }),
    [campaignid, adgroupid, keyword, adid, lpurl, gclid]
  );

  if (isLoading) return null;
  return (
    <footer>
      {!lightVersion && !isLpPage && (
        <div className={`logos ${lightVersion ? "hidden" : ""}`}>
          <h2 className="pb-[35px] text-center text-white font-bold">
            SCIPLAY'S GAMES
          </h2>
          <SciplayGames showTitles={false} />
        </div>
      )}
      {!lightVersion && (
        <div className="buttons flex flex-col justify-center items-center space-y-10 px-[10%] pt-20 pb-32 bg-black">
          <div className="">
            <Link to="/" aria-label="home">
              <StaticImage src="../images/logo.png" alt="" />
            </Link>
          </div>
          <Stores
            links={
              isLpPage
                ? ([
                    {
                      name: "Google",
                      desktop: replaceByDict(
                        "https://app.adjust.com/zuoayv2?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{adid}&lpurl={lpurl}&external_click_id={gclid}",
                        replaceHashed
                      ),
                    },
                    {
                      name: "Apple",
                      desktop: replaceByDict(
                        "https://app.adjust.com/imr1p88?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{adid}&lpurl={lpurl}&external_click_id={gclid}&redirect=https://apps.apple.com/us/app/jackpot-party-casino-slots/id575980917?ppid=6a92d9c1-406f-464b-a0ee-02ccb01ac1ce",
                        replaceHashed
                      ),
                    },
                  ] as StoreType[])
                : undefined
            }
          />
          {!isLpPage && (
            <div className="flex flex-col justify-center items-center  space-y-10">
              <div className="text-white text-2xl font-bold">FOLLOW US</div>
              <div className="flex justify-center items-center space-x-5">
                <a
                  target="_blank"
                  href="https://www.facebook.com/JackpotPartyCasinoCommunity"
                  className="block"
                  aria-label="facebook"
                >
                  <StaticImage
                    src="../images/socials/facebook.png"
                    alt=""
                    width={32}
                  />
                </a>
                <a
                  href="https://twitter.com/JackpotParty"
                  className="block"
                  target="_blank"
                  aria-label="twitter"
                >
                  <StaticImage
                    src="../images/socials/twitter.png"
                    alt=""
                    width={32}
                  />
                </a>
                <a
                  href="https://www.instagram.com/jackpotparty/"
                  className="block"
                  target="_blank"
                  aria-label="instagram"
                >
                  <StaticImage
                    src="../images/socials/instagram.png"
                    alt=""
                    width={32}
                  />
                </a>
                <a
                  href="https://www.youtube.com/c/JackpotPartyCasino"
                  target="_blank"
                  className="block"
                  aria-label="youtube"
                >
                  <StaticImage
                    src="../images/socials/youtube.png"
                    alt=""
                    width={32}
                  />
                </a>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="bottom flex flex-col xl:flex-row space-y-5 justify-between items-center text-gray-500 text-2xl">
        {lightVersion ? (
          <div>
            <StaticImage src="../images/powered-by.png" alt="" />
          </div>
        ) : (
          <a
            href="https://www.sciplay.com"
            target="_blank"
            aria-label="www.sciplay.com"
          >
            <StaticImage src="../images/powered-by.png" alt="" />
          </a>
        )}
        <p className="text-center footer-bottom">
          © Copyright {new Date().getFullYear()}. SciPlay Corporation. All Rights Reserved. |{" "}
          <a
            href="https://www.sciplay.com/terms-of-service#!/terms"
            target="_blank"
          >
            Terms of Service
          </a>{" "}
          |{" "}
          <a
            href="https://www.sciplay.com/terms-of-service#!/privacy"
            target="_blank"
          >
            Privacy Policy
          </a>{" "}
          |{" "}
          <a
            href="https://www.sciplay.com/terms-of-service#!/cookies"
            target="_blank"
          >
            Cookies
          </a>{" "}
          |{" "}
          <a
            href="https://www.sciplay.com/responsible-play"
            target="_blank"
          >
            Responsible Gaming
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer
